import { useCallback } from 'react'
import { dispatch } from 'store'
import { aiAvatarThunks } from 'store/features/aiAvatar/thunks'
import { AvatarSource } from 'store/types/aiAvatar'
import { IMyFilesMediaItem, IUploadMediaItem } from 'types/media'
import { useFileFormatValidator } from 'hooks/useFileFormatValidator'

export const useAvatarUpload = () => {
  const validateFiles = useFileFormatValidator('image')

  const handleFilesUpload = useCallback(
    async (files: File[] | FileList) => {
      if (!files || !files.length) return
      const valid = validateFiles(Array.from(files))
      if (!valid.length) return

      const uploadItem: IUploadMediaItem = {
        id: crypto.randomUUID(),
        type: 'image',
        file: valid[0]
      }
      dispatch(aiAvatarThunks.uploadAvatar([uploadItem]))
    },
    [validateFiles]
  )

  const handleMediaLibFiles = useCallback((files: IMyFilesMediaItem[]) => {
    const file = files?.[0]
    if (!file) return

    dispatch(
      aiAvatarThunks.setAvatar({
        id: String(file.id),
        url: file.filePath,
        source: AvatarSource.MY_FILES,
        width: file.width,
        height: file.height
      })
    )
  }, [])

  const handleRemoveAvatar = useCallback(() => {
    dispatch(aiAvatarThunks.clearAvatar())
  }, [])

  const handleSelectPublicAvatar = useCallback(
    (id: string, url: string, gender: string, aspectRatio: string) => {
      dispatch(
        aiAvatarThunks.setAvatar({
          id,
          url,
          source: AvatarSource.PUBLIC
        })
      )
      // Commit the panel's chosen aspect ratio alongside the avatar — Redux holds
      // a ratio only while a public avatar is selected (cleared on remove).
      dispatch(aiAvatarThunks.setAvatarAspectRatio(aspectRatio))
      // Auto-pick a voice matching the avatar's gender from the current language.
      dispatch(aiAvatarThunks.selectSpeakerByGender(gender))
    },
    []
  )

  return {
    handleFilesUpload,
    handleMediaLibFiles,
    handleRemoveAvatar,
    handleSelectPublicAvatar
  }
}
